import { NgClass } from "@angular/common";
import {
    ChangeDetectorRef,
    Component,
    ElementRef,
    HostBinding,
    Input,
    OnInit,
    ViewChild,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { NgbTooltip } from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from "@ngx-translate/core";
import { HotkeyDirective } from "../../directives/hotkey/hotkey.directive";
import { BaseComponent } from "../base-component/base.component";

@Component({
    selector: "rask-save-button",
    styleUrls: ["../button/button.component.scss"],
    templateUrl: "./save-button.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        HotkeyDirective,
        NgClass,
        NgbTooltip
    ]
})
export class SaveButtonComponent extends BaseComponent implements OnInit {
    readonly cdRef = inject(ChangeDetectorRef);

    @Input() color: string;
    @ViewChild("content", { read: ElementRef,
        static: false }) content: ElementRef;
    @Input() defaultTooltip = true;
    @Input() form?: string;
    @Input() icon: string;
    iconOnly = false;
    label: string;
    @Input() selected: boolean;
    @Input() tooltipText: string;
    @Input() type = "button";

    private readonly translateService = inject(TranslateService);

    @HostBinding("attr.disabled") get getDisabledState() { return (this.disabled ? "" : null);}

    ngOnInit(): void {
        this.iconOnly = this.content?.nativeElement.childNodes.length === 0;
        this.label = this.translateService.instant("DEFAULT_BUTTON_LABEL_SPARA");
        this.tooltipText = this.tooltipText ?? `${this.label} ${this.translateService.instant("DEFAULT_HOTKEYS_CONTROL_S")}`;
        if (this.form) {
            this.type = "submit";
        }
        this.aid = "buttonSpara";
        super.ngOnInit();
    }
}
